import PageHeader from 'components/PageHeader';
import ListCreateButton from 'components/buttons/ListCreateButton';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import ProjectsTableWithFilters from './ProjectsTableWithFilters';

const ProjectsListPage = (): JSX.Element => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId="projects.list-page.title"
                    showBreadcrumb
                    buttons={
                        <div>
                            <ListCreateButton
                                permissions={['CREATE.PROJECTS']}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => navigateWithReturn('/projects/new')}
                                labelId="projects.list-page.add-new"
                                newLabelId="new-entity.project"
                            />
                        </div>
                    }
                />
                <ProjectsTableWithFilters />
            </div>
        </PaddedLayout>
    );
};

export default ProjectsListPage;
